export default {
    title: "Adresa",
    back: 'Nazad',
    municipality: {
        label: "Grad",
        placeholder: "Izaberi svoj grad",
    },
    street: {
        label: "Ulica",
        placeholder: "Unesi naziv svoje ulice",
    },
    number: {
        label: "Broj",
        placeholder: "Unesi svoj broj ulice",
    },
    button: "Sačuvaj",
    successMessage: "Adresa je uspješno sačuvana.",
};
